import React from "react";
import Layout from "../components/Layout";
import Map from "../components/Map";
import Sponsors from "../components/Sponsors";

const Schedule = () => {
  return (
    <Layout>
      <div class="slider-area">
        <div class="single-slider hero-overly slider-height2 slider-bg2 d-flex align-items-center">
          <div class="container">
            <div class="row justify-content-center ">
              <div class="col-xxl-12">
                <div class="hero-caption hero-caption2">
                  <h2>Schedule</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <section class="shedule-area section-padding">
        <div class="container">
          <div class="row">
            <div class="col-xl-5 col-lg-6 col-md-6">
              <div class="section-tittle  mb-30">
                <h2>Schedule</h2>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-lg-11">
              <div class="nav-button">
                <nav>
                  <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a
                      class="nav-link active"
                      id="nav-one-tab"
                      data-bs-toggle="tab"
                      href="#nav-one"
                      role="tab"
                      aria-controls="nav-one"
                      aria-selected="true"
                    >
                      17th Aug
                    </a>
                    <a
                      class="nav-link"
                      id="nav-two-tab"
                      data-bs-toggle="tab"
                      href="#nav-two"
                      role="tab"
                      aria-controls="nav-two"
                      aria-selected="false"
                    >
                      18th Aug
                    </a>
                    <a
                      class="nav-link"
                      id="nav-three-tab"
                      data-bs-toggle="tab"
                      href="#nav-three"
                      role="tab"
                      aria-controls="nav-three"
                      aria-selected="false"
                    >
                      19th Aug
                    </a>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="tab-content" id="nav-tabContent">
            <div
              class="tab-pane fade show active"
              id="nav-one"
              role="tabpanel"
              aria-labelledby="nav-one-tab"
            >
              <div class="row justify-content-center">
                <div class="col-lg-11">
                  <div class="shedule-wrapper">
                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Registration And Breakfast</h4>
                            </a>
                            <p>- Mal Practice</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>8:30 am</span>
                        </div>
                      </div>
                    </div>

                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Opening Remarks And Keynote</h4>
                            </a>
                            <p>- Aaron Ottix</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>10:00 am</span>
                        </div>
                      </div>
                    </div>

                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Web Accessible Designs</h4>
                            </a>
                            <p>- Frank Senbeans</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>11:30 am</span>
                        </div>
                      </div>
                    </div>

                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Building Communities</h4>
                            </a>
                            <p>- Ken Tucky</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>12:30 am</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="nav-two"
              role="tabpanel"
              aria-labelledby="nav-two-tab"
            >
              <div class="row justify-content-center">
                <div class="col-lg-11">
                  <div class="shedule-wrapper">
                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Registration And Breakfast</h4>
                            </a>
                            <p>- Mal Practice</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>8:30 am</span>
                        </div>
                      </div>
                    </div>

                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Opening Remarks And Keynote</h4>
                            </a>
                            <p>- Aaron Ottix</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>10:00 am</span>
                        </div>
                      </div>
                    </div>

                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Web Accessible Designs</h4>
                            </a>
                            <p>- Frank Senbeans</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>11:30 am</span>
                        </div>
                      </div>
                    </div>

                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Building Communities</h4>
                            </a>
                            <p>- Ken Tucky</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>12:30 am</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="nav-three"
              role="tabpanel"
              aria-labelledby="nav-three-tab"
            >
              <div class="row justify-content-center">
                <div class="col-lg-11">
                  <div class="shedule-wrapper">
                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Registration And Breakfast</h4>
                            </a>
                            <p>- Mal Practice</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>8:30 am</span>
                        </div>
                      </div>
                    </div>

                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Opening Remarks And Keynote</h4>
                            </a>
                            <p>- Aaron Ottix</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>10:00 am</span>
                        </div>
                      </div>
                    </div>

                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Web Accessible Designs</h4>
                            </a>
                            <p>- Frank Senbeans</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>11:30 am</span>
                        </div>
                      </div>
                    </div>

                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Building Communities</h4>
                            </a>
                            <p>- Ken Tucky</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>12:30 am</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="nav-four"
              role="tabpanel"
              aria-labelledby="nav-four-tab"
            >
              <div class="row justify-content-center">
                <div class="col-lg-11">
                  <div class="shedule-wrapper">
                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Registration And Breakfast</h4>
                            </a>
                            <p>- Mal Practice</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>8:30 am</span>
                        </div>
                      </div>
                    </div>

                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Opening Remarks And Keynote</h4>
                            </a>
                            <p>- Aaron Ottix</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>10:00 am</span>
                        </div>
                      </div>
                    </div>

                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Web Accessible Designs</h4>
                            </a>
                            <p>- Frank Senbeans</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>11:30 am</span>
                        </div>
                      </div>
                    </div>

                    <div class="single-items">
                      <div class="shedule-items">
                        <div class="shedule-left">
                          <div class="job-tittle">
                            <a href="job_details.html">
                              <h4>Building Communities</h4>
                            </a>
                            <p>- Ken Tucky</p>
                          </div>
                        </div>
                        <div class="price">
                          <span>12:30 am</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </Layout>
  );
};

export default Schedule;
